<template>
  <div class="holder">
    <div v-if="extra_time_view">
      <div style="display: grid;    justify-content: center;">
        <squizzy-squids
            :mouth="mouth"
        />
        <p>Waiting for the Timer to run out...</p>
      </div>
    </div>
    <div class="question-choices" v-else :data-grid="choices.length">
        <choice-card
            v-for="(choice, index) in choices"
            :key="choice.index"
            :text="choice.answer"
            :index="index"
            :correct="choice.correct"
            :selectedChoice="selectedChoice === choice.id"
            :selectedOption="selectedOption"
            @change="selectAnswer(choice)"
            :class="{
        'selected-answer':
          selectedChoice === choice.id || choiceIsSelected(choice.id)
      }"
            :answerClass="choiceClasses"
            :correct_option="choice.correct"
            :disabled="isAnswerSubmitted"
        />
      <star-power></star-power>
    </div>
  </div>
</template>

<script>
import StarPower from '../../components/StarPower';
import ChoiceCard from "./ChoiceCard";
import SquizzySquids from "../../components/general/SquizzySquid";
import {store} from "@/store/store.js";
import Vue from "vue";
import CircularJSON from "circular-json";

export default {
  components: {
    ChoiceCard,
    StarPower,
    SquizzySquids
  },
  props: {
    isAnswerSubmitted: {
      type: Boolean,
      default: false
    },
    choices: {
      type: Array,
      required: true
    },
    question_id: {
      type: Number,
      required: true
    },
    correct_option: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      choiceClasses:{},
      selectedChoice: null,
      selectedOption:null,
      s:10,
      ms:30000,
      i: 1,
      milliseconds_remaining_at_answer:0,
      milliseconds_to_answer:0,
      seconds_at_answer:0,
      extra_time_view:false,
      times_up:false,
      countDown:30,
      mouth:"happy",
      // time_out_view:false
    };
  },
  mounted()
  {
    let context = this;
    context.setDate();
    context.countDownTimer();
    context.extra_time_view = false;

    // console.log("Choices Array:", this.choices);


  },
  computed:{
    points()
    {
      return Math.round((this.ms/30));
    },
  },
  methods: {
    countDownTimer () {
      var context = this;
      if (context.countDown >= 1) {
        setTimeout(() => {
          context.countDown -= 1
          context.countDownTimer()
        }, 1000)
      }else
      {
        context.times_up = true;
        context.extra_time_view = false
      }
    },
   finalScores(correct)
   {
     // this.milliseconds_to_answer =(30000-msta);
     // this.milliseconds_remaining_at_answer = msta;
     // this.seconds_at_answer=sta;

     let points;
     let points_hybrid;
     let _msremaining;
     let _mstaken;
     let _timeTaken;
     if (correct)
     {
       points = 1000+Math.round((this.milliseconds_remaining_at_answer/30));
       points_hybrid = Math.round(1000+(1-(this.milliseconds_to_answer/30000/2))*1000);//[1-(r/q/2)]p
       _msremaining =this.milliseconds_remaining_at_answer;
       _mstaken = this.milliseconds_to_answer;
       _timeTaken = this.milliseconds_to_answer/1000
     }else
     {
       points = 0;
       points_hybrid = 0;
       _msremaining =this.milliseconds_remaining_at_answer;
       _mstaken = this.milliseconds_to_answer;
       _timeTaken = this.milliseconds_to_answer/1000
     }
     return {'points':points,'points_hybrid':points_hybrid,'msremaining':_msremaining,'mstaken':_mstaken,'_timeTaken':_timeTaken};
   },
   setDate(){
      this.isZero(this.ms);
      setTimeout(()=>{
        this.setDate()
      },10);
    },
     is_int(value){
      if((parseFloat(value/100) === parseInt(value/100)) && !isNaN(value)){
        i++;
        this.s-= 1;
      } else {
        i++;
      }
    },
     isZero(value){
      if(value === 0){
        this.ms = 0;
      }
      else{
        this.ms -= 10;
      }
    },
    // Resolve answer
    selectAnswer(choice) {

      // console.log("Selected Choice:", choice);
      // console.log("Correct Value:", choice.correct);

      // console.log("Choice Selected:", choice); 

      this.$store.commit('SET_QUESTION_ANSWERED',true);
      // var pusher = new Pusher('e50fb6be6b7df82fb347', {
      //   cluster: 'ap2'
      // });
      // pusher.logToConsole = true;
      // var channel = store.state.channel;
      const channelString = localStorage.getItem("channel");
      const channel = CircularJSON.parse(channelString);
      let context = this;

      // //set extra time view to true and wait until timer runs out
      context.extra_time_view = true;

      let msta = context.ms;
      let sta = context.countDown;

      context.milliseconds_to_answer =(30000-msta);
      context.milliseconds_remaining_at_answer = msta;
      context.seconds_at_answer=sta;

      if (choice.correct) {
        this.$store.commit('ADD_ANSWER_CORRECT',true);
        let scoreF = context.finalScores(true);
        // Score correctly
        context.$store.commit('score', {last_question:this.$store.state.round+1,milliseconds_remaining:scoreF.msremaining,time:scoreF._timeTaken,milliseconds_taken:scoreF.mstaken,true: true,points_hybrid:scoreF.points_hybrid,score:scoreF.points,answer:choice.answer,question_id:this.question_id});
      } else {
        this.$store.commit('ADD_ANSWER_CORRECT',false);
        // Score incorrectly
        let scoreF = context.finalScores(false);
        context.$store.commit('score', {last_question:context.$store.state.round+1,milliseconds_remaining:scoreF.msremaining,time:scoreF._timeTaken,milliseconds_taken:scoreF.mstaken,false: false,points_hybrid:0,score:0,answer:choice.answer,question_id:this.question_id});
      }
      // channel.bind('check_question_responses', function(data) {
      //   console.log(data)
      //   // if (data.id == context.$store.state.player.matchSlug) {
      //     //after event fired set timeout view to false
      //     context.markThisQuestion(choice)
      //   // }
      // });

      Echo.channel("tuni-clear-abyss").listen("TriviaCheckQuestionResponses", (datas) => {
      context.markThisQuestion(choice)
    });
    },
    choiceIsSelected(choiceKey) {
      if (this.selectedChoice) {
        // shortcut for a more snappy client experience
        return this.selectedChoice === choiceKey;
      }
    },
    markThisQuestion(choice){
        // choiceClasses
        if (choice.correct)
        {
          this.choiceClasses = { correct: true,incorrect: false, selected:true}
          // Call down the stars!
          this.$store.dispatch('starPower');
        }else
        {
          this.choiceClasses = { correct: false,incorrect: false, selected:true}
        }
        this.selectedChoice = choice.id;
        this.selectedOption = choice.option;
        this.$emit("answered", true);
        // Pause game state (effects buttons)
        this.$store.commit('pauseGame', 'pause');
        // Check if game is over
        this.$store.commit('isGameOver');
    },
    // countDownTimerAfterClickAnswer (time,choice) {
    //   var context = this;
    //   if (time >= 1) {
    //     setTimeout(() => {
    //       time -= 1
    //       context.countDownTimerAfterClickAnswer(time,choice)
    //     }, 1000)
    //   }else
    //   {
    //    context.markThisQuestion(choice)
    //     context.extra_time_view = false;
    //   }
    // },
  }
};
</script>

<!--<style lang="sass" scoped>-->
<!--.holder-->
<!--  display: grid-->
<!--  //grid-template-columns: 1fr 1fr-->
<!--  //grid-template-rows: 1fr 1fr-->
<!--  //gap: 0.5rem-->
<!--  padding: 0.5rem-->
<!--  //overflow: scroll-->
<!--  height: 235px-->

<!--.question-choices-->
<!--  display: grid-->
<!--  grid-template-columns: 1fr 1fr-->
<!--  grid-template-rows: 1fr 1fr-->
<!--  gap: 0.5rem-->
<!--  padding: 0.5rem-->
<!--  overflow: scroll-->
<!--  height: 235px-->

<!--.question-choices[data-grid="2"] .choice-card-->
<!--  grid-row: 1 / -1-->

<!--.question-choices[data-grid="3"] .choice-card:last-child-->
<!--  grid-column: 1 / -1-->
<!--</style>-->


<style lang="sass" scoped>
.question-choices
  display: grid
  grid-template-columns: 1fr 1fr
  grid-template-rows: 1fr 1fr
  gap: 0.5rem
  padding: 0.5rem
  overflow: scroll
  height: 335px

.question-choices[data-grid="2"] .choice-card
  grid-row: 1 / -1

.question-choices[data-grid="3"] .choice-card:last-child
  grid-column: 1 / -1
</style>
